import script from "./SummaryReportBaseCoBuild.vue?vue&type=script&setup=true&lang=js"
export * from "./SummaryReportBaseCoBuild.vue?vue&type=script&setup=true&lang=js"

import "./SummaryReportBaseCoBuild.vue?vue&type=style&index=0&id=e043d4a2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e043d4a2"]])

export default __exports__